import { of } from 'rxjs';
import { VimeUtils } from './vime-utils';
export class VimePlayerKeyboard {
  constructor(document, options) {
    this.document = document;
    this.options = options;
    this.ready$ = of(true);
    // TODO: builtin keyboard events do not work in vime 5.0.31, setup manually
    // https://github.com/vime-js/vime/issues/174
    this.__keyboardHandler = e => {
      switch (e.code) {
        case 'Space':
          VimeUtils.setPlay(this.player, null);
          break;
        case 'Left': // IE/Edge specific value
        case 'ArrowLeft':
        case 'Right': // IE/Edge specific value
        case 'ArrowRight':
          // eslint-disable-next-line no-case-declarations
          const isFwd = e.code.includes('Right');
          VimeUtils.jump(this.player, isFwd ? 'fwd' : 'bwd');
          break;
        case 'KeyF':
          this.setFullscreen(null);
          break;
        case 'KeyM':
          this.setMute(null);
          break;
        case 'Escape':
          this.setFullscreen(false);
          break;
      }
    };
  }
  initialize(player) {
    this.player = player;
    this.bindKeyboardHotkeys();
  }
  bindKeyboardHotkeys() {
    if (this.options.enable) this.document.addEventListener('keydown', this.__keyboardHandler);
  }
  unbindKeyboardHotkeys() {
    this.document.removeEventListener('keydown', this.__keyboardHandler);
  }
  // will toggle if no boolean is given
  setFullscreen(explicitState = null) {
    const player = this.player;
    if (!player) return false;
    if (!this.options.fullscreenToggle) return false;
    if (typeof explicitState === 'boolean') {
      if (explicitState === true && !player.isFullscreenActive) player.enterFullscreen();
      if (explicitState === false && player.isFullscreenActive) player.exitFullscreen();
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      player.isFullscreenActive ? player.exitFullscreen() : player.enterFullscreen();
    }
  }
  // will toggle if no boolean is given
  setMute(explicitState = null) {
    const player = this.player;
    if (!player) return false;
    if (typeof explicitState === 'boolean') {
      player.muted = explicitState;
    } else {
      player.muted = !player.muted;
    }
  }
  destroy() {
    this.unbindKeyboardHotkeys();
  }
}